import { useRef, useState } from "react";
import styled from "styled-components";
import demoImg from "../../assets/demoImg.svg";
import useGenerateImg from "../../hooks/useGenerateImg";
import { useEffect } from "react";
import { addDoc, doc, setDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../authentication/firebase";
import { CircularProgress, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useDispatch, useSelector } from "react-redux";
import { userRecipesActions } from "../../store/userRecipesSlice";
import uploadImg from "../../utils/uploadImg";
import AddIcon from "@mui/icons-material/Add";
import { alertActions } from "../../store/alertSlice";
import LoadingButton from "../LoadingButton";
import { generateId } from "../../utils/recipesHandler";
import { units } from "../../utils/constants";

const ingredientMeasures = "us";

export default function EditRecipe({ handleBackdrop, data }) {
  if (!data.savedIngredients || data.savedIngredients?.length === 0) {
    data.savedIngredients = data.extendedIngredients
      ? [...data.extendedIngredients]
      : [...data.ingredients];
  }
  let steps = [];
  data.steps !== undefined
    ? (steps = data.steps)
    : data.analyzedInstructions?.forEach((instruction) =>
        instruction.steps?.forEach((item) => steps.push(item.step))
      );

  const uid = auth.currentUser?.uid;

  const [recipeData, setRecipeData] = useState({
    title: data.title,
    summary: data.summary,
    image: data.image,
    readyInMinutes: data.readyInMinutes,
    steps,
    savedIngredients: data.savedIngredients,
    servings: data.servings,
  });
  const [loading, setLoading] = useState({
    image: false,
    saveChanges: false,
  });

  const fileInputRef = useRef(null);

  const isAdmin = useSelector((state) => state.user.info.isAdmin);

  const dispatch = useDispatch();

  const imageGeneration = useGenerateImg();

  const uploadBtnHandler = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const reader = new FileReader();
    reader.onload = async () => {
      if (reader.readyState === 2) {
        const img = { name: event.target.files[0].name, data: reader.result };
        // handle the file upload here
        setRecipeData((current) => {
          const updatedData = { ...current };
          updatedData.image = img;
          return updatedData;
        });
      }
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  function recipeDataHandler(e) {
    setRecipeData((current) => ({
      ...current,
      [e.target.name]: e.target.value,
    }));
  }
  function stepsChangeHandler(value, index) {
    setRecipeData((current) => {
      const updatedSteps = [...current.steps];
      updatedSteps[index] = value;
      return {
        ...current,
        steps: updatedSteps,
      };
    });
  }

  function ingredientsChangeHandler(e, index) {
    const { name, value } = e.target;
    console.log("name", name, value);
    setRecipeData((current) => {
      const updatedIngredients = [...current.savedIngredients];
      if (name === "nameClean") {
        updatedIngredients[index].nameClean = value;
      } else if (name === "unit") {
        updatedIngredients[index].measures[ingredientMeasures].unitShort =
          value;

        units.forEach((unit) => {
          if (unit.unit === value) {
            updatedIngredients[index].measures[ingredientMeasures].unitLong =
              unit.name;
          }
        });
      } else {
        if (updatedIngredients[index]?.measures) {
          updatedIngredients[index].measures[ingredientMeasures].amount = value;
        } else {
          updatedIngredients[index].amount = value;
        }
      }
      return { ...current, savedIngredients: updatedIngredients };
    });
  }

  function ingredientDeleteHandler(index) {
    setRecipeData((current) => {
      let updatedIngredients = [...current.savedIngredients];
      console.log("updated", updatedIngredients);
      updatedIngredients.splice(index, 1);
      return { ...current, savedIngredients: updatedIngredients };
    });
  }

  function addIngredientBtnHandler() {
    setRecipeData((current) => {
      const updatedIngredients = [...current.savedIngredients];
      updatedIngredients.push({
        nameClean: "",
        image: "",
        measures: {
          [ingredientMeasures]: {
            amount: 1,
            unitLong: "Piece",
            unitShort: "piece",
          },
        },
      });
      return { ...current, savedIngredients: updatedIngredients };
    });
  }
  function stepDeleteHandler(index) {
    setRecipeData((current) => {
      let updatedSteps = [...current.steps];
      console.log("updated", updatedSteps);
      updatedSteps.splice(index, 1);
      return { ...current, steps: updatedSteps };
    });
  }
  function addStepHandler() {
    setRecipeData((current) => ({ ...current, steps: [...current.steps, ""] }));
  }

  function servingsChangeHandler(newValue) {
    if (newValue !== 0) {
      setRecipeData((current) => {
        data.savedServings = newValue;
        let updatedData = { ...current };
        updatedData.servings = newValue;
        updatedData.savedIngredients = updatedData.savedIngredients.map(
          (ingredient, index) => {
            let ingredientAmount = data.extendedIngredients?.[index]
              ? data.extendedIngredients[index].measures?.[ingredientMeasures]
                  .amount
              : data.ingredients?.[index]?.amount;

            ingredientAmount = parseFloat(
              ((ingredientAmount / data.servings) * newValue).toFixed(2)
            );
            return {
              ...ingredient,
              amount: ingredientAmount,
              measures: data.extendedIngredients
                ? {
                    [ingredientMeasures]: {
                      ...ingredient.measures?.[ingredientMeasures],
                      amount: ingredientAmount,
                    },
                  }
                : null,
            };
          }
        );
        return updatedData;
      });
    }
  }

  async function renderImg() {
    try {
      setLoading((current) => ({ ...current, image: true }));
      const url = await imageGeneration(
        recipeData.title,
        recipeData.savedIngredients,
        recipeData.steps,
        data.id
      );
      data.image = url;
      setRecipeData((current) => ({
        ...current,
        image: url,
      }));
      setLoading((current) => ({ ...current, image: false }));
      //   const docRef = doc(db, `${data.recipeType}Recipes`, data.id);
      //   const res = await setDoc(docRef, data);
      //   console.log("res", res);
    } catch (e) {
      console.log("recipe generate error, details page", e);
    }
  }

  async function saveChangesHandler() {
    // editedChangesHandler(recipeData)
    try {
      setLoading((current) => ({ ...current, saveChanges: true }));
      console.log("recipe data", { ...data, ...recipeData });
      let newImage = recipeData.image;
      if (recipeData.image.data) {
        newImage = await uploadImg(recipeData.image, "uploadedRecipeImages");
      }
      const newId = generateId();
      let newData = {
        ...data,
        ...recipeData,
        image: newImage,
        uid,
      };
      if (
        isAdmin &&
        (data.recipeType === "gpt" || data.recipeType === "converted")
      ) {
        await updateDoc(doc(db, `${data.recipeType}Recipes`, data.id), newData);
        dispatch(
          alertActions.setAlert({
            title: "Recipe edited successfully by admin",
            messageType: "success",
          })
        );
        handleBackdrop(newData);
        return;
      } else if (data.recipeType === "converted") {
        console.log("new data", data.recipeType, newData);
        await setDoc(doc(db, "convertedRecipes", data.id), newData, {
          merge: true,
        });
        dispatch(
          userRecipesActions.updateUserRecipe({
            recipeType: data.recipeType,
            data: newData,
          })
        );
        dispatch(
          alertActions.setAlert({
            title: "Recipe edited successfully",
            messageType: "success",
          })
        );
      } else {
        newData = { ...newData, originId: data.id, id: newId };
        dispatch(
          alertActions.setAlert({
            title: "Edited recipe added to favorites page",
            messageType: "success",
          })
        );
      }
      console.log("new id ", newId);
      await setDoc(doc(db, "editedRecipes", newId), newData);
      handleBackdrop(newData);
    } catch (e) {
      console.log("error while saving edited changes", e);
      dispatch(
        alertActions.setAlert({
          title: "Failed to edit recipe",
          messageType: "error",
        })
      );
    } finally {
      setLoading((current) => ({ ...current, saveChanges: false }));
    }
  }

  //   useEffect(() => {
  // servingsChangeHandler(1);

  // fetchInstacartRecipeLink();
  // console.log("recipe details", data);
  //   }, []);

  return (
    <StyledDetails>
      <div className={`heading`}>
        <div className="title">
          <input
            name="title"
            placeholder="Title"
            value={recipeData.title}
            onChange={recipeDataHandler}
          />
        </div>

        <button className="icon" onClick={(e) => handleBackdrop(false)}>
          {<CloseIcon htmlColor="#F79C16" fontSize="large" />}
        </button>
      </div>
      <div className="content">
        <div className="main">
          <div className="img-div">
            <div className="img">
              <img
                src={recipeData.image.data || recipeData.image || demoImg}
                alt="plate"
              />
              <div className="btns">
                <button onClick={renderImg}>
                  {loading.image ? (
                    <CircularProgress
                      style={{
                        color: "#a91beb",
                        width: 18,
                        height: 18,
                      }}
                    />
                  ) : (
                    <>
                      <AutoFixHighIcon htmlColor="#a91beb" fontSize="small" />{" "}
                      <span>Generate</span>
                    </>
                  )}
                </button>
                <>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <button onClick={uploadBtnHandler}>
                    <FileUploadIcon fontSize="small" /> Upload
                  </button>
                </>
              </div>
            </div>
          </div>
          <div className="info">
            <textarea
              name="summary"
              placeholder="Description"
              rows="5"
              value={recipeData.summary}
              onChange={recipeDataHandler}
            />
            <div className="details">
              <div className="size">
                <h5>Servings:</h5>
                <Tooltip placement="top" title="Change servings">
                  <input
                    className="small-input"
                    type="number"
                    placeholder="Servings"
                    inputMode="decimal"
                    min={1}
                    max={25}
                    step={1}
                    value={recipeData.servings}
                    onChange={(e) =>
                      servingsChangeHandler(parseInt(e.target.value))
                    }
                  />
                </Tooltip>
              </div>
              <div className="time">
                <h5>Cooking Time:</h5>
                <input
                  type="number"
                  step={1}
                  className="small-input"
                  name="readyInMinutes"
                  placeholder="Cooking Time"
                  value={recipeData.readyInMinutes}
                  onChange={recipeDataHandler}
                />
                <p>min</p>
              </div>
            </div>
            <div className="btns">
              <LoadingButton
                title={"Save Changes"}
                className="secondary-btn"
                loading={loading.saveChanges}
                onClick={saveChangesHandler}
              />
            </div>
          </div>
        </div>
        <div className="mid main">
          <div className="ingredients-box">
            <h5>Ingredients</h5>
            <div className="ingredients">
              {recipeData.savedIngredients.map((ingredient, index) => (
                <div className="ingredient">
                  {/* <p className="name">
                    {ingredient.nameClean?.[0].toUpperCase() +
                      ingredient.nameClean?.slice(1)}
                  </p> */}
                  <input
                    name="nameClean"
                    placeholder="Name"
                    value={ingredient.nameClean}
                    onChange={(e) => ingredientsChangeHandler(e, index)}
                  />
                  <input
                    className="small-input"
                    type="number"
                    step={1}
                    key={index}
                    name="amount"
                    placeholder="Quantity"
                    value={`${ingredient.measures?.[ingredientMeasures].amount}`}
                    onChange={(e) => ingredientsChangeHandler(e, index)}
                  />
                  {/* <p className="unit">
                    {ingredient.measures?.[ingredientMeasures].unitShort}
                  </p> */}
                  <select
                    defaultValue={
                      ingredient.measures?.[ingredientMeasures].unitShort
                    }
                    name="unit"
                    placeholder="Unit"
                    onChange={(e) => ingredientsChangeHandler(e, index)}
                  >
                    {units.map(({ name, unit }) => (
                      <option key={unit} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>

                  <button
                    className="icon"
                    onClick={(e) => ingredientDeleteHandler(index)}
                  >
                    <CloseIcon fontSize="small" />
                  </button>
                </div>
              ))}
            </div>
            <button
              className="add-ingredient"
              onClick={addIngredientBtnHandler}
            >
              <AddIcon /> Add Ingredient
            </button>
          </div>
        </div>
        <div className="steps">
          <h5>Steps</h5>
          {recipeData.steps?.map((step, index) => (
            <div key={index}>
              <span>{index + 1}.</span>
              <textarea
                value={step}
                placeholder={`Step ${index + 1}.`}
                onChange={(e) => stepsChangeHandler(e.target.value, index)}
              />
              <button className="icon" onClick={() => stepDeleteHandler(index)}>
                <CloseIcon fontSize="small" />
              </button>
            </div>
          ))}
          <button className="add-step" onClick={addStepHandler}>
            <AddIcon /> Add Step
          </button>
        </div>
      </div>
    </StyledDetails>
  );
}

const StyledDetails = styled.div`
  /* display: flex;
  flex-direction: column;
  gap: 20px; */
  background-color: var(--background-color);
  li {
    list-style: circle;
    line-height: 1.4;
  }
  input {
    width: 320px;
    border-width: 1px;
    padding: 2px;
    border-radius: 0;
    /* height: 34px; */
    border: none;
    border-bottom: 1px solid var(--gray-color);
    &:focus {
      border-color: var(--primary-color);
      border-width: 2px;
    }
  }
  .small-input {
    width: 70px;
    padding: 0px 2px;
    /* border-color: var(--gray-color); */
  }
  textarea {
    border-color: var(--gray-color);
    padding: 8px;
    border-radius: 12px;
    line-height: 1.4;
  }
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    min-height: 46px;
    padding: 10px 0;
    .title {
      display: flex;
      align-items: center;
      gap: 12px;
      h3 {
        font-weight: 300;
        color: var(--text-light-color);
      }
    }
  }
  .content {
    width: 98%;
    margin: auto;
    .main {
      display: flex;
      gap: 20px;
      margin: 10px auto;
      .img-div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        min-width: 150px;
        min-height: 200px;
        .loader {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .img {
          position: relative;
          img {
            width: 100%;
            border-radius: var(--radius);
          }
          .btns {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            position: absolute;
            bottom: 5%;
            left: 50%;
            transform: translateX(-50%);
            button {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 4px;
              background-color: var(--background-color);
              color: var(--text-light-color);
              padding: 8px 0;
              box-shadow: 1px 1px 4px var(--shadow);
              &:hover {
                transform: scale(1.04);
              }
              span {
                background: linear-gradient(
                  90deg,
                  #a91beb,
                  #f23c9d
                ); /* Your gradient */
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text; /* For Firefox */
                color: transparent;
              }
            }
          }
        }
      }
      .info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex-grow: 1;
        .details {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          }
          h5 {
            color: var(--secondary-dark-color);
          }
          p {
            font-weight: 600;
          }
        }
      }
    }
    .mid {
      margin: 20px 0;
      .ingredients-box {
        h5 {
          margin-bottom: 8px;
        }
        .ingredients {
          display: flex;
          flex-direction: column;
          /* width: max(400px, 100%); */
          gap: 8px;

          .ingredient {
            gap: 20px;
            display: grid;
            grid-template-columns: 320px 80px 100px auto;
            align-items: center;
            button:hover {
              color: var(--primary-color);
            }
          }
        }
        .add-ingredient {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          background-color: transparent;
          color: var(--primary-color);
          border: 1px solid var(--primary-color);
          margin-top: 16px;
          &:hover {
            background-color: var(--primary-color);
            color: white;
          }
        }
      }
      .info-div {
        margin-bottom: 10px;
      }
    }
    .steps {
      h5 {
        margin-bottom: 8px;
      }
      div {
        display: flex;
        gap: 4px;
        margin: 12px 0;
        align-items: center;
        span {
          font-weight: 600;
          width: 20px;
        }
        textarea {
          width: 100%;
        }
        button.icon {
          color: var(--gray-color);
          &:hover {
            color: var(--primary-color);
          }
        }
      }
      .add-step {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: transparent;
        color: var(--primary-color);
        border: 1px solid var(--primary-color);
        margin-top: 16px;
        &:hover {
          background-color: var(--primary-color);
          color: white;
        }
      }
    }
  }
  @media (max-width: 700px) {
    .main {
      flex-wrap: wrap;
      justify-content: center;
      .info {
        width: 100%;
      }
    }
    .content .main .img-div {
      width: 100%;
    }
  }
  @media (min-width: 700px) {
    .img-div {
      width: 400px;
    }
  }
`;
